/**
 * Array entity form operation type.
 */
export const OperationType = {
  ADD: 'add',
  DELETE: 'delete',
  ORDER: 'order',
  EDIT: 'edit',
  CANCEL: 'cancel',
  SUBMIT: 'submit',
};
